<template>
  <b-col md="12" class="mt-5">
    <div class="avatar-box d-flex">
      <div class="avatar my-auto">
        <b-img src="/iconss/organizzazioni.png"></b-img>
      </div>
      <div class="black-box">
        <div v-if="!register">
          <AppLogin v-if="userType == 'organization'"></AppLogin>
          <template v-else>
            <h4 class="text-center org_area">Area Organizzazioni</h4>
            <p class="text-center">
              Hai bisogno di una traduzione? Carica il tuo documento e ricevi una traduzione rivista da una persona
              madrelingua.
            </p>
            <!-- <b-button pill size="sm" variant="outline-danger" to="/users/register/organization" class="m-2"
              >Registrati</b-button
            > -->
            <b-button pill size="sm" variant="outline-danger" @click="register=!register">Registrati</b-button>
            <b-button pill size="sm" variant="primary" to="/login/organization" class="m-2">Accedi</b-button>
            <div class="text-right mt-2">
              <router-link to="/organizations/help" class="text-danger small">Istruzioni Organizzazioni</router-link>
            </div>
          </template>
        </div>
        <div v-else>
          <AppLogin v-if="userType == 'organization'"></AppLogin>
          <template v-else>
            <h4 class="text-center org_area">La tua organizzazione è già accreditata?</h4>
            <p class="text-left">
              Se sì, clicca su "Registrati".<br>
              Avrai bisogno del codice che abbiamo già inviato al responsabile della tua organizzazione.<br>
              Se no, clicca su "Accreditati".<br>
              Compila il form in tutte le sue parti e attendi il codice di accesso per registrarti.
            </p>
            <b-button pill size="sm" variant="primary" to="/accreditation" class="m-2"
              >Accreditati</b-button
            >

            <b-button pill size="sm" variant="outline-danger" to="/users/register/organization" class="m-2"
              >Registrati</b-button
            >
            <div class="text-right mt-2">
              <router-link to="/organizations/help" class="text-danger small">Istruzioni Organizzazioni</router-link>
            </div>
          </template>
        </div>
      </div>
    </div>
  </b-col>
</template>
<script>
import AppLogin from "@/components/CardLogin";

export default {
  name: "HomeOrg",
  components: { AppLogin },
  props: ["userType"],
  data() {
    return {
      register: false
    };
  },
};
</script>

<style scoped>
.org_area {
  color: #f49538 !important;
  font-weight: bold;
}
</style>
